export const COUPON_FETCH_REQUEST = 'coupon-fetch-request';
export const COUPON_FETCH_SUCCESS = 'coupon-fetch-success';
export const COUPON_FETCH_FAILURE = 'coupon-fetch-failure';